import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DialogOverlayComponent {}
